export const SET_IS_LOADING = 'bom/SET_IS_LOADING'
export const SET_QUERY = 'bom/SET_QUERY'
export const SET_BOMS = 'bom/SET_BOMS'
export const SET_PRODUCTS = 'bom/SET_PRODUCTS'
